import getExceptionImage from '@/constants/schedule/ScheduleExceptionImageHelpers'
import DateFormatToken from '@/constants/date/DateFormatToken'
import dayjs from '@/services/date'

const { DMMYY, YYYYMMDD } = DateFormatToken

/**
 * Represents a schedule exception such as holidays, events, or special days
 * @param {string} id - The id of the schedule exception unique each session, tracks local updates
 * @param {string} inheritedFrom - The inherited from (e.g., "clientGroup")
 * @param {string} title - The title of the schedule exception (e.g., "Christmas")
 * @param {string} dateLocal - The date of the schedule exception (e.g., "2025-01-01")
 */

export default class ScheduleException {
  constructor({
    id,
    inheritedFrom = null,
    title = 'Please add a title',
    dateLocal,
    img = null,
  }) {
    this.id = id
    this.inheritedFrom = inheritedFrom
    this.title = title
    this.dateMeta = dayjs(dateLocal, YYYYMMDD)

    // If img is not provided, auto-assign it using the helper so images persist in the session
    this.img = img ?? getExceptionImage(title, dateLocal)
  }

  get dateString() {
    return this.dateMeta.format(YYYYMMDD)
  }

  get dateLocal() {
    return this.dateMeta.format(DMMYY)
  }

  update({ id, dateLocal, title }) {
    this.id = id
    this.dateMeta = dayjs(dateLocal, YYYYMMDD)
    this.title = title

    const newImg = getExceptionImage(title, dateLocal)
    const shouldUpdateImage = _shouldUpdateImage(newImg, this.img)

    if (shouldUpdateImage) {
      this.img = newImg
    }
  }
}

function _shouldUpdateImage(newImg, currentImg) {
  const isNewDefault = newImg.includes('default')
  const isCurrentDefault = currentImg?.includes('default')

  const switchDefaultToSpecial = isCurrentDefault && !isNewDefault
  const switchSpecialToDefault = !isCurrentDefault && isNewDefault
  const switchSpecialToSpecial =
    !isCurrentDefault && !isNewDefault && newImg !== currentImg

  return (
    switchDefaultToSpecial || switchSpecialToDefault || switchSpecialToSpecial
  )
}
